import instance from "api/instance";

const orders = async (params) => {
	const response = await instance.get("/customer/orders/list",{
		params:params
	});
	if (response.status === 200) {
		return response.data;
	}
	
	return Promise.reject(response.data);
};

const ordersDetail = async (params) => {
	const response = await instance.get("/customer/orders/list",{
		params:params
	});
	if (response.status === 200) {
		return response.data;
	}
	
	return Promise.reject(response.data);
};

const createOrder = async (data) => {
	const response = await instance.post("/customer/orders/new",data);
	if (response.status === 201) {
		return response.data;
	}
	
	return Promise.reject(response.data);
};

const receiptRequired = async () => {
	const response = await instance.get("/customer/orders/receipt-required");
	if (response.status === 200) {
		return response.data;
	}

	return Promise.reject(response.data);
};




const ordersService = {
	orders,
	ordersDetail,
    createOrder,
	receiptRequired
};

export default ordersService;